<template>
  <div style="height: 100%;">
    <el-row style="height: 100%;margin-right: 10px;">
      <el-col :span="8" style="height: 100%;">
        <div class="add-content">
          <div class="title-form"><strong v-if="electronicObj.isAdd">创建围栏</strong><strong v-else>更新围栏</strong></div>
          <el-form style="margin-right: 40px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
            <el-form-item label="围栏名称" prop="circle_name">
              <el-input v-model="addEditForm.circle_name" placeholder="请输入围栏名称"></el-input>
            </el-form-item>
            <el-form-item label="围栏类型" prop="circle_type">
              <el-select v-fixZoom v-model="addEditForm.circle_type" style="width: 100%" placeholder="请选择围栏类型" @change="changeType">
                <el-option v-for="item in typeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="围栏行为" prop="circle_in_out">
              <el-select v-fixZoom v-model="addEditForm.circle_in_out" style="width: 100%" placeholder="请选择围栏行为">
                <el-option v-for="item in actionArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报警次数" prop="circle_sos_count">
              <el-select v-fixZoom v-model="addEditForm.circle_sos_count" style="width: 100%" placeholder="请选择报警次数">
                <el-option v-for="item in alarmArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报警时间" prop="time">
              <div>
                <div style="width: calc(100% - 80px);float: left;">
                  <el-time-picker v-fixZoom style="width: 100%;" is-range v-model="timeVal" format="HH:mm" value-format="HH:mm:ss" :clearable="false"
                                  range-separator="至" start-placeholder="开始" end-placeholder="结束" placeholder="选择时间范围">
                  </el-time-picker>
                </div>
                <div style="float: right"><el-button type="primary" @click="addTime()">添加</el-button></div>
                <div style="clear:both;"></div>
              </div>
            </el-form-item>
            <div style="height: 30px;color: #1A1A1A;margin-left: 40px" v-for="(item, index) in circleTime" :key="item.index">
              <span>生效时段{{ index + 1 }}：</span><span>{{ item.sos_start_time }} - {{ item.sos_end_time }}</span>
              <button class="my-btn" style="color: #ff6666;padding: 0 5px" @click="delTime(item)">删除</button>
            </div>
          </el-form>
          <div style="margin: 20px 30px 0">
            <el-row style="text-align: center">
              <el-col :span="12"><el-button type="danger" size="medium" @click="closeOpen()">返回</el-button></el-col>
              <el-col :span="12"><el-button type="success" size="medium" @click="submitAddEdit('addEditForm')">确定</el-button></el-col>
            </el-row>
          </div>
          <div style="height: 20px"></div>
        </div>
      </el-col>
      <el-col :span="16" style="height: 100%;">
        <add-edit-electronic-map ref="addEditMap" :addEditObj="addEditObj" @getMapArea="getMapArea"></add-edit-electronic-map>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {devicecircleadd, devicecircleupdate} from '../../../api/device'

import addEditElectronicMap from './addEditElectronicMap'
export default {
  name: 'addEditElectronic',
  components: {addEditElectronicMap},
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    electronicObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      deviceRow: '',
      typeArr: [{name: '圆形', id: 1}, {name: '多边形', id: 2}],
      actionArr: [{name: '禁止进入', id: 2}, {name: '禁止离开', id: 1}],
      alarmArr: [{name: '1', id: 1}, {name: '5', id: 5}, {name: '10', id: 10}, {name: '15', id: 15}, {name: '20', id: 20}],
      addEditForm: {
        did: '',
        circle_name: '',
        circle_type: '',
        circle_area: '',
        circle_in_out: '',
        create_tm: '',
        circle_sos_count: '',
        times: []
      },
      timeVal: ['09:00:00', '18:00:00'],
      circleTime: [],
      updatetime: [],
      addEditRules: {
        circle_area: [
          { required: true, message: '请输入围栏区域', trigger: 'blur' }
        ],
        circle_name: [
          { required: true, message: '请输入围栏名称', trigger: 'blur' }
        ],
        circle_type: [
          { required: true, message: '请选择围栏类型', trigger: 'change' }
        ],
        circle_in_out: [
          { required: true, message: '请选择围栏行为', trigger: 'change' }
        ],
        circle_sos_count: [
          { required: true, message: '请选择报警次数', trigger: 'change' }
        ]
      },
      day: '',
      addEditObj: {
        isAdd: true
      }
    }
  },
  created () {
    // console.log(this.electronicObj)
    this.deviceRow = this.electronicObj.deviceRow
    this.addEditObj.isAdd = this.electronicObj.isAdd
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    this.day = new Date().format('yyyy-MM-dd')
  },
  mounted () {
    if (!this.electronicObj.isAdd) {
      this.getEditData()
    }
  },
  methods: {
    getEditData () {
      let obj = this.electronicObj.electronicRow
      // console.log('167', obj)
      this.circleTime = obj.times
      this.addEditForm = {
        circle_area: obj.circle_area,
        circle_in_out: obj.circle_in_out,
        circle_name: obj.circle_name,
        circle_pid: obj.circle_pid,
        circle_type: obj.circle_type,
        create_tm: obj.create_tm,
        create_uid: obj.create_uid,
        circle_sos_count: obj.circle_sos_count,
        time: this.circleTime.length > 0 ? this.circleTime : ''
      }
      let vm = this
      setTimeout(() => {
        vm.$refs.addEditMap.getEditDataMap(obj)
      }, 2000)
    },
    addTime () {
      if (this.timeVal.length === 0 || this.timeVal[0] === '') {
        this.$message.warning('请选择报警时间')
      } else {
        let flag = true
        let time1 = new Date(this.day + ' ' + this.timeVal[0]).getTime()
        let time2 = new Date(this.day + ' ' + this.timeVal[1]).getTime()
        for (let i = 0; i < this.circleTime.length; i++) {
          let time3 = new Date(this.day + ' ' + this.circleTime[i].sos_start_time).getTime()
          let time4 = new Date(this.day + ' ' + this.circleTime[i].sos_end_time).getTime()
          if (time1 >= time3 && time1 < time4) {
            flag = false
          }
          if (time1 < time3 && time2 > time3) {
            flag = false
          }
        }
        if (flag) {
          let item = {sos_start_time: this.timeVal[0], sos_end_time: this.timeVal[1], device_circle_id: 0, id: 0}
          if (!this.electronicObj.isAdd) { // 编辑接口 1、新增时间 id =0  device_circle_id 有值。2、删除时间 id = 返回ID   device_circle_id 有值.3、保留不动不传
            item.device_circle_id = this.electronicObj.electronicRow.id
            this.updatetime.push(item)
          }
          this.circleTime.push(item)
        } else {
          this.$message.error('所选时间不能重复。')
        }
      }
    },
    delTime (item) {
      this.circleTime.remove(item)
      if (!this.electronicObj.isAdd) { // 编辑接口 1、新增时间 id =0  device_circle_id 有值。2、删除时间 id = 返回ID   device_circle_id 有值.3、保留不动不传
        this.updatetime.push(item)
      }
    },
    changeType () {
      this.addEditForm.circle_area = ''
      this.$refs.addEditMap.getChangeType(this.addEditForm.circle_type)
    },
    getMapArea (obj) {
      if (obj.type === 1) {
        this.getMapAreaCircle(obj.circleObj)
      } else if (obj.type === 2) {
        this.getMapAreaPolygon(obj.polygonArr)
      }
    },
    getMapAreaCircle (obj) {
      // console.log('Circle', obj)
      if (obj === '') {
        this.addEditForm.circle_area = ''
      } else {
        let aa = {
          point: {
            x: obj.point[1],
            y: obj.point[0]
          },
          radius: obj.radius
        }
        let area = JSON.stringify(aa)
        // console.log(55, area)
        this.addEditForm.circle_area = area
      }
    },
    getMapAreaPolygon (arr) {
      // console.log('Polygon', arr)
      if (arr.length === 0) {
        this.addEditForm.circle_area = ''
      } else {
        let points = {}
        for (let i = 0; i < arr.length; i++) {
          let arr1 = arr[i]
          let point = {x: arr1[1], y: arr1[0]}
          if (i === 0) {
            points['point1'] = point
          } else if (i === 1) {
            points['point2'] = point
          } else if (i === 2) {
            points['point3'] = point
          } else if (i === 3) {
            points['point4'] = point
          } else if (i === 4) {
            points['point5'] = point
          } else if (i === 5) {
            points['point6'] = point
          } else if (i === 6) {
            points['point7'] = point
          } else if (i === 7) {
            points['point8'] = point
          }
        }
        // console.log(points)
        let area = JSON.stringify(points)
        // console.log(55, area)
        this.addEditForm.circle_area = area
      }
    },
    closeOpen () {
      this.$emit('change', false)
      this.$emit('getFatherElectronic', {type: 'close'})
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.electronicObj.isAdd) {
            this.sendAddElectronic()
          } else {
            this.sendEditElectronic()
          }
        } else {
          return false
        }
      })
    },
    sendAddElectronic () {
      if (this.addEditForm.circle_area === '') {
        this.$message.error('请在地图上构建电子围栏。')
        return
      }
      let data = {
        did: this.deviceRow.id,
        circle_name: this.addEditForm.circle_name,
        circle_type: this.addEditForm.circle_type,
        circle_area: this.addEditForm.circle_area,
        circle_in_out: this.addEditForm.circle_in_out,
        create_tm: this.addEditForm.create_tm,
        circle_sos_count: this.addEditForm.circle_sos_count,
        times: this.circleTime
      }
      // console.log('添加', data)
      devicecircleadd(data).then(res => {
        this.$message({
          message: '成功新建围栏信息',
          type: 'success'
        })
        this.$emit('getFatherElectronic', {type: 'add'})
        this.$emit('change', false)
      }).catch(() => {})
    },
    sendEditElectronic () {
      if (this.addEditForm.circle_area === '') {
        this.$message.error('请在地图上构建电子围栏。')
        return
      }
      let data = {
        id: this.electronicObj.electronicRow.id,
        did: this.deviceRow.id,
        circle_name: this.addEditForm.circle_name,
        circle_type: this.addEditForm.circle_type,
        circle_area: this.addEditForm.circle_area,
        circle_in_out: this.addEditForm.circle_in_out,
        create_tm: this.addEditForm.create_tm,
        circle_sos_count: this.addEditForm.circle_sos_count,
        times: this.updatetime
      }
      devicecircleupdate(data).then(res => {
        this.$message({
          message: '成功编辑围栏信息',
          type: 'success'
        })
        this.$emit('getFatherElectronic', {type: 'edit'})
        this.$emit('change', false)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.add-content{
  max-height: 100%;
  overflow-y: auto;
}
.title-form{
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 18px;
  color: #1A1A1A;
}
.my-btn{
  background: none!important;
  border: none!important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/addEditElectronic.vue